import { NationalUniversityDetails } from "../types/nationalUniversityTypes";

export const nationalUniversityInitialValues: NationalUniversityDetails = {
  id: "",
  name: "",
  nameEn: "",
  settlement: {
    id: "",
  },
  address: "",
  addressEn: "",
  zipCode: "",
  website: "",
  logoRelativePath: "",
  isActive: true,
  file: {
    fileId: "",
    fileName: "",
    fileSize: 0,
    contentType: "",
    rootDirectory: "",
    relativePath: "",
    additionalMetadata: null,
  },
};
